import { Link } from "react-router-dom";
import Appartement from "../../assets/img407/20250306_112353.avif";
import Studio from "../../assets/img516/8980022986927334899.avif";
import "./preview.css";

export default function Preview() {
  return (
    <main>
      <div id="std-container">
        <article className="stdleft">
          <Link to="/appartement-407-4-etoiles-chatel-guyon">
            <div className="img-star-container">
              <img src={Appartement} alt="Appartement 407" loading="lazy" />
              <span className="star">&#11088;&#11088;&#11088;&#11088;</span>
            </div>
            <h3>Appartement 407</h3>
            <ul className="ul-disc">
              <li>
                <strong>38m²</strong> – spacieux et lumineux
              </li>
              <li>
                <strong>Classé 4 étoiles</strong>
              </li>
              <li>Balcon avec vue sur le parc thermal</li>
              <li>Parking privé (sur demande)</li>
              <li>
                Équipements modernes : cuisine équipée, lave-linge, TV grand
                écran
              </li>
            </ul>
          </Link>
        </article>
        <article className="stdright">
          <Link to="/studio-516-2-etoiles-chatel-guyon">
            <div className="img-star-container">
              <img src={Studio} alt="Studio 516" loading="lazy" />
              <span className="star">&#11088;&#11088;</span>
            </div>
            <h3>Studio 516</h3>
            <ul className="ul-disc">
              <li>
                <strong>19m²</strong> – idéal pour 1 ou 2 personnes
              </li>
              <li>
                <strong>Classé 2 étoiles</strong>
              </li>
              <li>Compact, bien aménagé</li>
              <li>Coin cuisine fonctionnel</li>
              <li>À deux pas des Thermes et des commerces</li>
            </ul>
          </Link>
        </article>
      </div>
    </main>
  );
}
